import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  //const user = JSON.parse(localStorage.getItem("user"))
  //const groups =String(user.groups);
//const rol = user.roles
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-flex align-items-center justify-content-between ">
          <h3 className="mb-0 font-size-18">{props.breadcrumbItem}</h3>
          <div className="page-title-right">
            <ol className="breadcrumb m-2">
              <BreadcrumbItem>
                <Link to="#">{props.title} </Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#"> {props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
